import { languageMap } from ".."

languageMap.abap = {
	comments: {
		line: '"',
	},
}
